import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NavLinksWithIcon, SubNavLinksWithIcon } from '../navigation';

@Component({
  selector: 'to-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkComponent {
  @Input() showIcon = false;
  @Input() nav: NavLinksWithIcon | SubNavLinksWithIcon;
}
